import { useCallback } from 'react';
import { useApiEndpoint } from './useApiEndpoint';

export const useApiRemove = <T>(path: string) => {
  const ServiceEndpoint = useApiEndpoint<T>(path);

  const call = useCallback(
    async (id?: string, data?: T) => {
      try {
        const response = await ServiceEndpoint.remove(id, data);
        return response.data;
      } catch (e: any) {
        if (e.error) {
          throw new Error(e.error);
        }
        throw e;
      }
    },
    [ServiceEndpoint],
  );

  return { call };
};
